import { render, staticRenderFns } from "./ShortVideo.vue?vue&type=template&id=2ca6f98e&scoped=true"
import script from "./ShortVideo.vue?vue&type=script&lang=js"
export * from "./ShortVideo.vue?vue&type=script&lang=js"
import style0 from "./ShortVideo.vue?vue&type=style&index=0&id=2ca6f98e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca6f98e",
  null
  
)

export default component.exports